import { render, staticRenderFns } from "./StatusFilterBar.vue?vue&type=template&id=3909f456&scoped=true"
import script from "./StatusFilterBar.vue?vue&type=script&lang=js"
export * from "./StatusFilterBar.vue?vue&type=script&lang=js"
import style0 from "./StatusFilterBar.vue?vue&type=style&index=0&id=3909f456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3909f456",
  null
  
)

export default component.exports